import './TitleBar.css';
import { FaBars as MenuIcon } from 'react-icons/lib/fa';
import { connect } from 'react-redux';
import { t } from 'i18next';
import React from 'react';
import { toggleSidebar } from '../../reducer/actions';

const TitleBar = ({
  title, extra = {
    extra: '',
  }, dispatch, children, fetchData,
}) => (
  <div className="TitleBar">

    <MenuIcon size={25}
      onClick={() => (dispatch(toggleSidebar()))}
    />
    <h1>{t(title, extra)}</h1>
    {children}
  </div>
);

export default connect(s => s)(TitleBar);
